import React, { memo } from 'react'
import styles from './PaymentPlanSideDialog.module.scss'
import RightSideDialog from '../../../../common/components/right-side-dialog/RightSideDialog'
import { AvailableOffer, SolarProductObject } from '../../../../model/solar-product/solar-product-with-recommendations'
import { Money } from '../../../../model/common/money'

type Props = {
    onCloseDialog: () => void;
    solarProduct: SolarProductObject | undefined;
    handleSelectPlan: (plan: AvailableOffer) => void;
}

const PaymentPlanSideDialog: React.FC<Props> = memo((props: Props) => {
    const { onCloseDialog, solarProduct, handleSelectPlan } = props;

    return (
        <RightSideDialog title='Select Payment Plan' onCloseDialog={onCloseDialog}>
            <div className={styles.container}>
                <div className={styles.plans}>
                    {solarProduct?.availableOffers?.map((x: AvailableOffer) => (
                        <div className={styles.plan} key={x.months}>
                            <div className={styles.planHeader}>
                                {x.months} months
                                <div className={styles.totalPayment}>
                                    Total Payment
                                    <div className={styles.planPrice}>
                                        {new Money(solarProduct?.solarProduct.price?.currency ?? '', solarProduct?.solarProduct?.price.amount * 0.3 + x.months * x.price.amount).toLocaleString()}
                                    </div>
                                </div>
                            </div>
                            <div className={styles.planDetails}>
                                <div className={styles.planDetail}>
                                    <div className={styles.detailName}>
                                        Initial Deposit
                                    </div>
                                    <div className={styles.detailValue}>
                                        30% - {new Money(solarProduct?.solarProduct.price?.currency ?? '', solarProduct?.solarProduct?.price.amount * 0.3).toLocaleString()}
                                    </div>
                                </div>
                                <div className={styles.planDetail}>
                                    <div className={styles.detailName}>
                                        Monthly Payment
                                    </div>
                                    <div className={styles.detailValue}>
                                        ₦{x.price.toLocaleString()}
                                    </div>
                                </div>
                            </div>
                            <div className={styles.btn} onClick={() => handleSelectPlan(x)}>
                                Select
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </RightSideDialog>
    )
})

export default PaymentPlanSideDialog